import { ListingsBySimilarQueryVariables } from '@/types/cate-graphql-generated-types'
import { nikaListingsToLegacyListings } from '@/utils/nika/listing-mapper'
import { legacyGeoFilterToNikaFilter } from '@/utils/nika/query-mapper'

import { reqListings } from '../api/api-nika'

export async function fetchListingBySimilar(variables: ListingsBySimilarQueryVariables) {
  const where = {
    administrative_area_net: { $gte: variables.areaMin, $lte: variables.areaMax },
    pricing_sell_value: { $gte: Math.floor(variables.priceMin / 100), $lte: Math.floor(variables.priceMax / 100) },
    property_rooms_all: { $gte: variables.roomsMin, $lte: variables.roomsMax },
  }
  const whereWithGeoFilter: Record<string, unknown> = legacyGeoFilterToNikaFilter(variables.geoSlugs, where)
  try {
    const { data } = await reqListings(whereWithGeoFilter, { page: 1, page_size: 10 })
    return data?.data.map((v) => nikaListingsToLegacyListings(v))
  } catch (e) {
    console.log(e)
    throw e
  }
}
